<div class="banner" role="banner">
  <h1>{{ 'pick.player.leaderboard.title' | translate }}</h1>
</div>

<div class="container">
  <div class="page-back-button-section" [routerLink]="['/games/pickaplayer']">
    <span class="material-icons me-2">navigate_before</span>{{ 'games.back.button.text' | translate }}
  </div>
</div>

<div class="container mt-4">
  <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
</div>
